export const REQUEST_PRODUCTS_SUGGESTIONS = 'zola/search/REQUEST_PRODUCTS_SUGGESTIONS';
export const RECEIVE_PRODUCTS_SUGGESTIONS = 'zola/search/RECEIVE_PRODUCTS_SUGGESTIONS';
export const REQUEST_COUPLES = 'zola/search/REQUEST_COUPLES';
export const RECEIVE_COUPLES = 'zola/search/RECEIVE_COUPLES';
export const REQUEST_VENDORS = 'zola/search/REQUEST_VENDORS';
export const RECEIVE_VENDORS = 'zola/search/RECEIVE_VENDORS';
export const SET_SEARCH_WORD = 'zola/search/SET_SEARCH_WORD';
